import { SET_BUY_ERROR_SINGLE } from './../const';

export default (buyErrorSingle) => {
    return {
      type: SET_BUY_ERROR_SINGLE,
      buyErrorSingle: buyErrorSingle
    }
};
